import React, { Component } from 'react';
import Measure from 'catalog/components/Measure';
import autobind from 'autobind-decorator';
import NewMeasure from 'catalog/components/NewMeasure';
import {connect} from 'react-redux'
import DroppableContext from 'catalog/containers/DroppableContext'
@connect(
    state => ({
        measureList: state.categories.measureList,
        activeCheckpoint: state.categories.activeCheckpoint
    })
)
export default class MeasureList extends Component {

    @autobind
    addMeasure(measure) {
        const measureList = [...this.state.measures, measure];
        this.setState({
            measures: measureList
        })
        this.props.updateMeasures({ ...this.props.checkpoint, measures: measureList })
    }

    render() {
        const { measureList, activeCheckpoint } = this.props;
        return (
                <div className="card-body">
                    <ul className="list-unstyled ml-5">
                        <li>
                            <NewMeasure checkpoint={activeCheckpoint} callback={this.addMeasure} />
                        </li>
                        <DroppableContext droppableId={'measure'}>
                        {
                            measureList.map(
                                (measure, id) =>
                                    <Measure id={id} measure={measure}
                                        key={`measure_${measure.id}`} />
                            )
                        }
                        </DroppableContext>
                    </ul>
                </div>
        )
    }
}